import DesktopTimeInput from './DesktopTimeInput'

export default DesktopTimeInput
